<div class="w-full mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <div class="titre3 dark:text-white">{{ 'DIFFUSION.PACKAGES_LIST_TITLE' | translate }}</div>
    <p class="text-sm font-medium text-gray-700 dark:text-white mt-2">{{ data.titre }}</p>
  </div>

  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    <ul class="list-disc list-inside">
      @for (locales of data.scormPackageNomLocales; track locales) {
        <li class="text-sm text-gray-700 dark:text-white py-1">
          {{ getNomPackage(locales) }}
        </li>
      }
    </ul>
  </div>

  <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
    <button (click)="onFermer()" type="button" class="btn-secondary-novo">
      {{ 'DIFFUSION.CANCEL' | translate }}
    </button>
  </div>
</div>
